"use client"

import Link from "next/link"

interface FooterNavigationProps {
  footerItems?: Array<{
    title: string
    subItems?: Array<{ url?: string; subItem: string }>
  }>
  lang?: string
  itemClassName?: string
}

export const FooterNavigation = ({ footerItems = [], lang = "vi", itemClassName }: FooterNavigationProps) => {
  if (!footerItems || footerItems.length === 0) {
    return null
  }

  const defaultItemClassName = "flex flex-col gap-3 min-w-24"
  const finalItemClassName = itemClassName || defaultItemClassName

  return (
    <>
      {footerItems.map((item, index) => {
        return (
          <div key={index} className={finalItemClassName}>
            {item.title && (
              <h3 className="text-[#242F3E] text-sm text-nowrap font-semibold leading-5.5">{item.title}</h3>
            )}
            {item.subItems && item.subItems.length > 0 && (
              <div className="flex flex-col gap-2">
                {item.subItems.map((subItem, subIndex) => {
                  const path = subItem?.url ?? ""
                  const normalizedPath = path.startsWith("/") ? path : `/${path}`
                  const url = path ? `/${lang}${normalizedPath}` : "#"
                  return (
                    <Link
                      key={subIndex}
                      href={url}
                      className="text-[#242F3E] text-sm leading-5.5 text-nowrap hover:text-[#4A9B4A] transition-colors cursor-pointer"
                    >
                      {subItem.subItem}
                    </Link>
                  )
                })}
              </div>
            )}
          </div>
        )
      })}
    </>
  )
}
